import Immutable from 'seamless-immutable'
import { amd50Constants } from '../constants'
import amd50Steps from '../../../shared/amd50Steps.json'

const initialState = Immutable({
  couponCode: null,
  couponClaimError: null,
  submitClaimError: null,
  amd50ClaimLoading: false,
  amd50Step: amd50Steps.CLAIM_COUPON,
  hash: null,
  shippingDetails: {
    firstName: null,
    lastName: null,
    email: null,
    phone: null,
    addrline1: null,
    addrline2: null,
    city: null,
    province: null,
    country: null,
    postalCode: null,
    tShirtSize: null,
  },
  terms: [],
  faq: [
    {
      id: 1,
      isOpen: false,
      problem: 'amd50.faq.question.01.problem',
      solution: 'amd50.faq.question.01.solution',
    },
    {
      id: 2,
      isOpen: false,
      problem: 'amd50.faq.question.02.problem',
      solution: 'amd50.faq.question.02.solution',
    },
    {
      id: 3,
      isOpen: false,
      problem: 'amd50.faq.question.03.problem',
      solution: 'amd50.faq.question.03.solution',
    },
    {
      id: 4,
      isOpen: false,
      problem: 'amd50.faq.question.04.problem',
      solution: 'amd50.faq.question.04.solution',
    },
    {
      id: 5,
      isOpen: false,
      problem: 'amd50.faq.question.05.problem',
      solution: 'amd50.faq.question.05.solution',
    },
    {
      id: 6,
      isOpen: false,
      problem: 'amd50.faq.question.06.problem',
      solution: 'amd50.faq.question.06.solution',
    },
    {
      id: 7,
      isOpen: false,
      problem: 'amd50.faq.question.07.problem',
      solution: 'amd50.faq.question.07.solution',
    },
    {
      id: 8,
      isOpen: false,
      problem: 'amd50.faq.question.08.problem',
      solution: 'amd50.faq.question.08.solution',
    },
    {
      id: 9,
      isOpen: false,
      problem: 'amd50.faq.question.09.problem',
      solution: 'amd50.faq.question.09.solution',
    },
    {
      id: 10,
      isOpen: false,
      problem: 'amd50.faq.question.10.problem',
      solution: 'amd50.faq.question.10.solution',
    },
  ],
})

const amd50Reducer = (state = initialState, action) => {
  let errorMessage

  switch (action.type) {
    case amd50Constants.CLAIM_COUPON_REQUEST:
      return {
        ...state,
        amd50ClaimLoading: true,
        couponClaimError: null,
      }

    case amd50Constants.SAVE_SHIPPING_FINAL_REQUEST:
      return {
        ...state,
        amd50ClaimLoading: true,
        submitClaimError: null,
      }

    case amd50Constants.CLAIM_COUPON_SUCCESS: {
      const { amd50Step, couponCode } = action.response
      return {
        ...state,
        couponCode,
        amd50ClaimLoading: false,
        amd50Step,
      }
    }

    case amd50Constants.CLAIM_COUPON_FAILURE: {
      const { errors } = action.error

      if (errors && errors.length) {
        errorMessage = errors[0].message
      } else if (errors && errors.message) {
        errorMessage = errors.message
      } else {
        errorMessage = '500'
      }
      return { ...state, amd50ClaimLoading: false, couponClaimError: errorMessage }
    }

    case amd50Constants.SAVE_SHIPPING_FINAL_FAILURE: {
      const { errors } = action.error
      if (errors && errors.length) {
        errorMessage = errors[0].message
      } else if (errors && errors.message) {
        errorMessage = errors.message
      } else {
        errorMessage = '500'
      }
      return { ...state, amd50ClaimLoading: false, submitClaimError: errorMessage }
    }

    case amd50Constants.SAVE_SHIPPING_FINAL_SUCCESS: {
      console.log(action.response)
      const {
        amd50Step,
        finalOrderDetails: { hash },
      } = action.response
      return {
        ...state,
        amd50ClaimLoading: false,
        amd50Step,
        hash,
      }
    }

    case amd50Constants.SAVE_SHIPPING_CACHE_SUCCESS: {
      const { amd50Step } = action.response
      return {
        ...state,
        amd50ClaimLoading: false,
        amd50Step,
      }
    }

    case amd50Constants.PREV_REDEEM_STATE:
      return {
        ...state,
        amd50Step: state.amd50Step - 1,
      }

    case amd50Constants.NEXT_REDEEM_STATE:
      return {
        ...state,
        amd50Step: state.amd50Step + 1,
      }

    case amd50Constants.CLEAR_REDEEM_STATE:
      return {
        ...state,
        amd50Step: 0,
        amd50ClaimLoading: false,
      }

    case amd50Constants.SAVE_SHIPPING_CACHE_REQUEST: {
      const { payload } = action.body
      return {
        ...state,
        shippingDetails: {
          ...state.shippingDetails,
          ...payload,
        },
      }
    }

    case amd50Constants.TERMS_SUCCESS: {
      const { payload } = action.response
      return {
        ...state,
        terms: [...payload],
      }
    }

    case amd50Constants.SET_FAQ_ACTIVE_REQUEST: {
      const { index } = action.body
      const {
        faq: {
          [index]: { isOpen },
        },
      } = state

      return {
        ...state,
        faq: [
          ...state.faq.slice(0, index),
          {
            ...state.faq[index],
            isOpen: !isOpen,
          },
          ...state.faq.slice(index + 1),
        ],
      }
    }

    default:
      return state
  }
}

export default amd50Reducer
